import { render, staticRenderFns } from "./ConsultaDeLicitacoes.vue?vue&type=template&id=1bb012ba&"
import script from "./ConsultaDeLicitacoes.vue?vue&type=script&lang=js&"
export * from "./ConsultaDeLicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaDeLicitacoes.vue?vue&type=style&index=0&id=1bb012ba&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports